import styles from "./changeClient.module.css"
import { Button, Modal } from "react-bootstrap"
import { useEffect, useState } from "react"
import AsyncSelect from "react-select/async"
import { Client, useClients } from "../../../../../lib/client"
import { useNavigate } from "react-router-dom"
import { setClients, setCurrentClient } from "../../../../../store/actions"
import { CurrentClient } from "../../../../../lib/currentClient"
import { useStoreShared } from "../../../../../store"
import { setPlayersList } from "../../../../../modules/players/store/actions"
import { useStorePlayers } from "../../../../../modules/players/store"
interface Props {
  showModal: boolean | undefined
  hideModal: any
}

export function ModalChangeClient(props: Props) {
  const [show, setShow] = useState(false)
  const { stateShared, dispatchShared } = useStoreShared()
  const { dispatchPlayers } = useStorePlayers()
  const [clients, ,] = useClients(stateShared.clients.length !== 0)
  const handleShow = () => setShow(true)
  const [, setShowSelect] = useState(false)
  const [options] = useState([{ value: " ", label: " " }])
  const navigate = useNavigate()

  useEffect(() => {
    if (stateShared.clients.length === 0 && clients) {
      dispatchShared(setClients(clients))
      clients.map((client: Client, index: number) => {
        options.push({ value: client.uuid, label: client.name })
      })
      setShowSelect(true)
    } else if (stateShared.clients && options.length === 1) {
      stateShared.clients.map((client: Client, index: number) => {
        options.push({ value: client.uuid, label: client.name })
      })
    }
  }, [clients])
  useEffect(() => {
    console.log("useEffect show modal")
    handleShow()
  }, [props.showModal])
  function close() {
    props.hideModal(false)
    setShow(false)
  }
  const filterClient = (inputValue: string) => {
    return options.filter((i) => i.label.toLowerCase().includes(inputValue.toLowerCase()))
  }
  const loadOptions = (inputValue: string, callback: (options: any[]) => void) => {
    setTimeout(() => {
      callback(filterClient(inputValue))
    }, 1000)
  }
  const onChangeSelectedOption = (e: any) => {
    const selectedOption = e
    if (selectedOption) {
      sessionStorage.setItem("currentClientName", selectedOption.label)
      sessionStorage.setItem("currentClientUuid", selectedOption.value)
      dispatchShared(
        setCurrentClient({
          name: selectedOption.label,
          uuid: selectedOption.value,
        } as CurrentClient)
      )
      dispatchPlayers(setPlayersList([]))
      props.hideModal(false)
      setShow(false)
      navigate("/")
      window.location.reload()
    }
  }
  return (
    <Modal dialogClassName="custom-dialog" show={show} onHide={close}>
      <Modal.Header closeButton>
        <Modal.Title>
          {" "}
          <span className={styles.title}>Change brand/client</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {stateShared.clients.length !== 0 && <AsyncSelect cacheOptions loadOptions={loadOptions} defaultOptions onChange={onChangeSelectedOption} />}
        {stateShared.clients.length === 0 && "Loading ..."}
      </Modal.Body>
      <Modal.Footer>
        <Button className={styles.btn} onClick={close}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
